import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const formatErr = (d) => {
  if (!d) return "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || "").filter(Boolean).join(" · ");
  return String(d);
};

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const redirect = new URLSearchParams(location.search).get("next") || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate(redirect);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-14 bg-[#FAF4F5]">
      <div className="w-full max-w-md bg-white border border-[#E8DCDD] rounded-sm p-8">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-2">Student account</div>
        <h1 className="font-serif text-3xl text-[#2D2628] mb-1">Sign in</h1>
        <p className="text-sm text-[#6B5E62] mb-6">Access your purchased courses and ebooks.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] tracking-[0.2em] uppercase text-[#6B5E62]">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full border border-[#E8DCDD] rounded-sm px-3 py-2 text-sm mt-1"/>
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label className="text-[10px] tracking-[0.2em] uppercase text-[#6B5E62]">Password</label>
              <Link to="/forgot-password" data-testid="login-forgot-link"
                className="text-[10px] tracking-[0.14em] uppercase text-[#8C4A57] hover:underline">Forgot?</Link>
            </div>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full border border-[#E8DCDD] rounded-sm px-3 py-2 text-sm mt-1"/>
          </div>
          <button type="submit" disabled={busy} data-testid="login-submit"
            className="w-full bg-[#8C4A57] text-white text-[12px] tracking-[0.14em] uppercase font-semibold py-3 rounded-sm hover:bg-[#6f3945] transition disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-xs text-[#6B5E62] text-center mt-6">
          No account yet? <Link to="/register" className="text-[#8C4A57] font-semibold">Register</Link>
        </p>
        <p className="text-[10px] text-[#6B5E62] text-center mt-3 italic">
          Registered with the same email you used at checkout? Your purchases attach automatically.
        </p>
      </div>
    </div>
  );
}
